import {Injectable} from '@angular/core';
import {ErrorModel, HttpErrorHandler, HttpResponseStatus, Priority} from '@spartacus/core';
import {HttpErrorResponse} from '@angular/common/http';
import {isCartError, voucherExceededError, voucherInvalidError} from '@spartacus/cart/base/core';
import {BehaviorSubject} from 'rxjs';

/**
 * Error handler for Bad Vouchers requests with http status 400.
 */
@Injectable({
  providedIn: 'root',
})
export class BadVoucherRequestHandler extends HttpErrorHandler {
  responseStatus = HttpResponseStatus.BAD_REQUEST;

  public voucherError = new BehaviorSubject<ErrorModel>({type: null, message: null});

  /**
   * Increased prio otherwise Spartacus handler gets picked instead.
   */
  getPriority(): Priority {
    return Priority.HIGH;
  }

  hasMatch(errorResponse: HttpErrorResponse): boolean {
    const voucherErrors: ErrorModel [] = this.getErrors(errorResponse).filter(errorObj => this.isVoucherError(errorObj));
    if (voucherErrors?.length > 0) {
      this.voucherError.next(voucherErrors[0]);
    }
    return (
      super.hasMatch(errorResponse) && (
        this.getErrors(errorResponse).some(this.isVoucherError)
      )
    );
  }

  handleError(): void {
    // empty error handler to avoid the default global messages
  }

  protected getErrors(response: HttpErrorResponse): ErrorModel[] {
    return (response.error?.errors || []).filter(
      (error: ErrorModel) => error.type !== 'JaloObjectNoLongerValidError'
    );
  }

  isVoucherError(errorObj): boolean {
    return isCartError(errorObj) || voucherExceededError(errorObj) ||
      voucherInvalidError(errorObj) || errorObj.message === 'coupon.already.exists.cart' ||
      errorObj.message === 'You have entered too many voucher codes. Please try again later.' ||
      errorObj.message === 'coupon.invalid.cart.entry';
  }
}
